__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "knowledge_search_ui_mfe_admin";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@cocounsel/prometheus", "3.0.102", () => (Promise.all([__webpack_require__.e(727), __webpack_require__.e(759), __webpack_require__.e(216), __webpack_require__.e(935), __webpack_require__.e(802)]).then(() => (() => (__webpack_require__(2216))))));
			register("@datadog/browser-rum", "6.33.0", () => (Promise.all([__webpack_require__.e(337), __webpack_require__.e(621)]).then(() => (() => (__webpack_require__(337))))));
			register("@tanstack/react-query", "5.101.0", () => (Promise.all([__webpack_require__.e(247), __webpack_require__.e(193)]).then(() => (() => (__webpack_require__(3247))))));
			register("axios", "1.20.0", () => (Promise.all([__webpack_require__.e(581), __webpack_require__.e(114)]).then(() => (() => (__webpack_require__(6581))))));
			register("dayjs", "1.11.21", () => (__webpack_require__.e(446).then(() => (() => (__webpack_require__(446))))));
			register("dompurify", "3.4.16", () => (__webpack_require__.e(977).then(() => (() => (__webpack_require__(7977))))));
			register("i18next", "23.16.8", () => (Promise.all([__webpack_require__.e(978), __webpack_require__.e(666)]).then(() => (() => (__webpack_require__(4978))))));
			register("moment", "2.31.0", () => (__webpack_require__.e(178).then(() => (() => (__webpack_require__(6178))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(7950))), 1);
			register("react-i18next", "13.5.0", () => (__webpack_require__.e(68).then(() => (() => (__webpack_require__(687))))));
			register("react-responsive", "10.0.1", () => (__webpack_require__.e(657).then(() => (() => (__webpack_require__(9657))))));
			register("react-router", "7.18.2", () => (Promise.all([__webpack_require__.e(923), __webpack_require__.e(2)]).then(() => (() => (__webpack_require__(3923))))));
			register("react", "18.3.1", () => (() => (__webpack_require__(5043))), 1);
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(453).then(() => (() => (__webpack_require__(6453))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};